// store.ts
import { create } from 'zustand';
import React from 'react';

interface TextareaStore {
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  setTextareaRef: (ref: React.RefObject<HTMLTextAreaElement>) => void;
}

export const useMobileTextareaStore = create<TextareaStore>((set) => ({
  textareaRef: React.createRef(),
  setTextareaRef: (ref) => set({ textareaRef: ref }),
}));
